import { render, staticRenderFns } from "./CardProfiles.vue?vue&type=template&id=6066dd88&scoped=true"
import script from "./CardProfiles.vue?vue&type=script&lang=ts"
export * from "./CardProfiles.vue?vue&type=script&lang=ts"
import style0 from "./CardProfiles.vue?vue&type=style&index=0&id=6066dd88&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6066dd88",
  null
  
)

export default component.exports